var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"step",attrs:{"icon":"progress-check"}},[_vm._v("\n  "+_vm._s(_vm.tag)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }